import {
  algoliasearch,
  SearchClient,
  LegacySearchMethodProps,
} from 'algoliasearch'

// Consider no environment variables locally
export const indexName = process.env.GATSBY_ALGOLIA_INDEX_NAME ?? ''
export const indexNameEnglish =
  process.env.GATSBY_ALGOLIA_INDEX_NAME_ENGLISH ?? ''
export const suggetionsIndexName =
  process.env.GATSBY_ALGOLIA_SUGGESTIONS_INDEX_NAME ?? ''

export const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID ?? '',
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY ?? '',
)

export const searchClientEmptyQueryDisabled: SearchClient = {
  ...searchClient,
  search(requests: LegacySearchMethodProps) {
    if (requests.every(({ params }) => !params?.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: '',
          params: '',
        })),
      })
    }

    return searchClient.search(requests)
  },
}
